import type { ThemeValidations } from '../../typings/theme-context.js';
import type { ValidationLevel } from '../ValidationWrapperInternal.js';

export const DEFAULT_TEXT_COLOR = '#d43517';

export function getValidationTextColor(theme: ThemeValidations, level: ValidationLevel = 'error'): string {
  return (
    (level === 'warning' ? theme.validationsTextColorWarning : theme.validationsTextColorError) || DEFAULT_TEXT_COLOR
  );
}
